function makeSafeStorage(storage) {
  const store = {
    getItem: storage.getItem.bind(storage),
    setItem: storage.setItem.bind(storage),
    removeItem: storage.removeItem.bind(storage),

    format(options) {
      return makeSafeStorage({
        getItem(key) {
          return options.parse(storage.getItem(key))
        },
        setItem(key, value) {
          storage.setItem(key, options.prepare(value))
        },
        removeItem: store.removeItem,
      })
    },

    use(options) {
      return makeSafeStorage(options(store))
    },
  }

  return store
}

function json() {
  return {
    parse: JSON.parse,
    prepare: JSON.stringify,
  }
}

function scope(prefix) {
  return function (storage) {
    return {
      getItem(key) {
        return storage.getItem(`${prefix}:${key}`)
      },
      setItem(key, value) {
        storage.setItem(`${prefix}:${key}`, value)
      },
      removeItem(key) {
        storage.removeItem(`${prefix}:${key}`)
      },
    }
  }
}

function safeGet(fallback) {
  return function (store) {
    return {
      getItem(key) {
        try {
          return store.getItem(key)
        } catch (err) {
          return fallback()
        }
      },
      setItem: store.setItem,
      removeItem: store.removeItem,
    }
  }
}

function safeSet() {
  return function (store) {
    return {
      setItem(key, value) {
        try {
          store.setItem(key, value)
        } catch (err) {
          console.log('err', err)
        }
      },
      getItem: store.getItem,
      removeItem: store.removeItem,
    }
  }
}

function fail(message) {
  throw new TypeError(message || 'Safe Storage error')
}

function createStorage(options) {
  let store = makeSafeStorage(options.storage).format(json()).format(options)

  if (options.scope) {
    store = store.use(scope(options.scope))
  }

  if (options.fallback) {
    store = store.use(safeGet(options.fallback))
  }

  if (options.safeSet !== false) {
    store = store.use(safeSet())
  }

  return store
}

const safeStorage = createStorage({
  storage: localStorage,
  parse: (raw) => {
    if (raw) {
      return raw
    }
    fail()
    return undefined
  },
  prepare: (data) => data,
  fallback: () => {},
  scope: 'app',
})

export { safeStorage }
